jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').size() !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupScrollTriggers();
	setupSearch();
	setupFadeIn();
	
}

function setupFadeIn(){
	
	jQuery(window).on('load', function(){
		jQuery('body').addClass('loaded');
	});
	
}

function setupMobileMenu(){
	
	jQuery("#mobile-nav").mmenu({

	}, {

		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
			
		}
		
	});
	
}

function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).size();
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

function setupScrollTriggers(){

	const elements = document.querySelectorAll('div[class^="wp-block-"]:not(.set-up)');
	const options = {
		root: document.body,
		rootMargin: '0px',
		threshold: 0
	}
	
	var observer = new IntersectionObserver((entries) => {
		
		entries.forEach(entry => {
			if(entry.isIntersecting)
				entry.target.classList.add('active');
		});
	});
	
	elements.forEach(element => {
		element.classList.add('set-up');
		observer.observe(element);
	});

}

function setupSearch() {
	
	jQuery('#search-container').on('click', function(e){
		e.stopPropagation();
		jQuery('html').addClass('search-is-open');
		jQuery('#s').focus();
	});
	
	jQuery('html').on('click', function(){
		jQuery('html').removeClass('search-is-open');
	});
	
}
